module.exports = __webpack_public_path__ + "img/compado_mountains_1200x629.b97dea9d.png";